import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as PenIcon } from '../../../assets/img/pen.svg';
import { ReactComponent as AIIcon } from '../../../assets/img/ai.svg';
import { useTranslation } from 'react-i18next';

function ArticleScreen() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const modules = [
        { id: 1, label: 'article.index.yes', path: '/article/generator', icon: PenIcon },
        { id: 2, label: 'article.index.no', path: '/article/ideas', icon: AIIcon }
    ];

    return (
        <Container className="py-5">
            <Row className="mb-5">
                <Col xs={12} className="text-center">
                    <h2 className="title">{t('article.index.title')}</h2>
                </Col>
            </Row>

            <Row className="mb-4 g-4 justify-content-center">
                {modules.map((module) => {
                    const IconComponent = module.icon;
                    return (
                        <Col key={module.id} xs={12} md={6} className="card-custom-container">
                            <div
                                className="card-custom-content d-flex align-items-center justify-content-center flex-column text-center"
                                onClick={() => navigate(module.path)}
                                role="button"
                                style={{ aspectRatio: '1 / 1', overflow: 'hidden' }}
                            >
                                <IconComponent className="mb-3 card-svg" />
                                <h3 className="card-title text-capitalize">
                                    {t(module.label)}
                                </h3>
                            </div>
                        </Col>
                    );
                })}
            </Row>
        </Container>
    );
}

export default ArticleScreen;
